var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 67607"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 24119",
    y: 6,
    width: 2,
    height: 6,
    rx: 1,
    fill: "#EA1212"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 24120",
    x: 4,
    y: 3,
    width: 2,
    height: 9,
    rx: 1,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 24121",
    x: 8,
    width: 2,
    height: 12,
    rx: 1,
    fill: "#D9D9D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNetwork);
export default __webpack_public_path__ + "static/media/IconNetwork.ac39c39aef33d390dbbb5c13ec50faa1.svg";
export { ForwardRef as ReactComponent };